<template>
  <section :id="`comp_id_${compProps.elementId}`">
    <component :is="compName" :compProps="filterTabData" :filterPanelHasShadow="compProps.mate.privateProps.hasShadow || false" :compId="(compProps.elementId + '')" @action="actionHandle"></component>
    <component :is="servCompName" :compProps="compProps" :payLoad="payLoad" :compIndex="compIndex" @init="initHandle" @finish="finishHandle"></component>
  </section>
</template>
<script>
import FiltersWrapper from '@/components/FiltersWrapper'
import serviceComps from './../serviceComps'
import mixin from '@/mixin/compMixin.js'

export default {
  mixins: [mixin],
  components: {
    FiltersWrapper,
    ...serviceComps
  },
  props: {
    compProps: {
      type: Object,
      default: function() {
        return {}
      }
    },
    compIndex: {
      type: String,
      default: function() {
        return ''
      }
    }
  },
  data() {
    return {
      payLoad: {},
      filterTabData: {
        filters: {},
        houses: {
          mode: '0',
          items: [],
          totalCount: 0,
          privateProps: {},
          pageIndex: 1
        }
      }
    }
  },
  computed: {
    compName() {
      return 'filtersWrapper'
    }
  },
  methods: {
    /**
     * 初始化接口，用于获得业务组件的初始化数据
     */
    initHandle(payLoad) {
      const initType = payLoad.type
      switch (initType) {
      case 'initFilter':
        this.filterTabData.filters = payLoad.data
        break
      case 'initHouse':
        this.filterTabData.houses = payLoad.data
        break
      default:
      }
    },
    /**
     * UI交互组件对用户的交互派发接口，将UI组件用户交互的事件信息发送给业务组件
     */
    actionHandle(payLoad) {
      this.payLoad = payLoad
    },
    /**
     * 当业务组件处理完用户的交互动作后，将结果通过这个接口返回给Ui组件
     * 不要嫌麻烦，这样做的目的是彻底剥离业务与视图，达到视图和业务的自由组合目的
     */
    finishHandle(payLoad) {
      const finishType = payLoad.type
      switch (finishType) {
      case 'updateFilter':
        this.filterTabData.filters = payLoad.data
        break
      case 'updateHouse':
        this.filterTabData.houses = this.fixHouseNum(payLoad.data)
        break
      case 'favirote':
        {
          const index = this.filterTabData.houses.items.findIndex((item) => {
            return item.unitId === payLoad.data.id
          })
          this.filterTabData.houses.items[index].isLike = payLoad.data.isLike
        }
        break
      case 'loadMoreHouses':
        this.filterTabData.houses = this.fixHouseNum(payLoad.data)
        break
      default:
      }
    },
    // 保证房屋数量不超出运营配置的最大值
    fixHouseNum(houses) {
      // eslint-disable-next-line
      let { totalCount, pageIndex, maxShowNumber, items } = houses
      const curItems = this.filterTabData.houses.items
      const curHouseNumber = curItems.length || 0
      const addNumber = maxShowNumber - curHouseNumber > items.length ? items.length : maxShowNumber - curHouseNumber
      items = items.splice(0, addNumber)
      const newItems = curItems.concat(items)
      return {
        ...houses,
        items: newItems
      }
    }
  }
}
</script>
